var TableModal = function() {

	var comp = $('[data-component="table-modal"]');
	var compTable = $('[data-component="table"]');
	var html;
	var _self;

	this.init = function() {

		this.appendData();

	};

	this.appendData = function(){
		compTable.on('click', '[data-modal-id="table-modal"]', function(e) {			
			$('.layer.to-modal').show();
			
			if ($(e.target).is("a")) {
				e.stopPropagation();
				return;
			}
			
			html = $(this).parent().html();
			
			var thead = $(this).closest("table").find("thead tr").html();

			html = html.split('data-modal-id="table-modal"').join('');

			comp.find(".first-table > thead").append(thead);
			comp.find('.to-add-content').prepend('<tr class="to-remove">' + html + '</tr>');
			
			_self = $(this);
			
			setTimeout(function() {
				_self.addClass('opened-modal');
				$('.layer.to-modal').hide();
			}, 1100);
			
		});

		$(document).on('click', '.close-modal, .modal-bg', function(){
			if(compTable.find('.opened-modal').length > 0) {
				comp.find(".first-table > thead").empty();
				comp.find(".overflow").scrollLeft(0);
				comp.find('.to-remove').remove();
				compTable.find('.opened-modal').removeClass('opened-modal');
			}
		});

	};

	return this.init();

};
